export default class MoreTopics {
  constructor() {
    const contents = document.querySelector('.section_topics');
    if (!contents) {
      return;
    }
    this.cellContainers = contents.querySelectorAll('._cellContainer');
    this.more = contents.querySelector('._more');
    this.close = contents.querySelector('._close');

    this.pageNum = 0;

    this.setup()
  }

  setup () {
    if (!this.more) {
      return;
    }
    this.more.addEventListener('click', (event) => {

      ++this.pageNum;
      this.cellContainers.forEach((elm, index) => {
        if(this.pageNum>=index)
        {
          elm.classList.remove("off");
        }
      });
      if(this.pageNum>=this.cellContainers.length-1)
      {
        this.more.classList.add("off");
        this.close.classList.add("on");
      }
    });
    this.close.addEventListener('click', (event) => {

      this.pageNum = 0;
      this.cellContainers.forEach((elm, index) => {
        if(index!=0)
        {
          elm.classList.add("off");
        }
      });
      this.more.classList.remove("off");
      this.close.classList.remove("on");
    });
  }

}